import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-competency',
  templateUrl: './competency.component.html',
  styleUrls: ['./competency.component.scss']
})
export class CompetencyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
